"use client";

import { Skeleton } from "@/components/ui/skeleton";

/**
 * Page-shaped loading placeholder for the PDF sidebar viewer. Replaces the
 * full-overlay spinner — same absolute-positioned overlay shape so the parent
 * container layout doesn't shift, but mimics PDF page proportions with
 * staggered text-line skeletons. Same animation pattern as ThreadListSkeleton.
 */
export function PdfPageSkeleton() {
  return (
    <div className="absolute inset-0 overflow-hidden bg-muted/20 px-6 pt-4">
      <div className="mx-auto flex max-w-[600px] flex-col gap-4">
        {[0, 1].map((page) => (
          <div
            key={page}
            className="aspect-[8.5/11] rounded-sm border border-border/40 bg-background p-6 shadow-sm"
          >
            {/* Header */}
            <Skeleton
              className="mb-3 h-5 w-2/3"
              style={{ animationDelay: `${page * 80}ms` }}
            />
            {/* Lines */}
            {[
              "95%", "100%", "92%", "98%",
              "60%", "100%", "90%", "85%", "100%", "75%",
            ].map((width, i) => (
              <Skeleton
                key={i}
                className="my-2 h-3"
                style={{ width, animationDelay: `${page * 80 + i * 40}ms` }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
